<template>
  <div>
    <a-modal :visible="visible" :title="addFlag ? '新增' : '编辑'" @cancel="cancelHandler" @ok="okHandler">
      <a-form-model
        ref="formState"
        :model="formState"
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 16 }"
        :rules="addFlag ? rules : undefined"
      >
        <a-form-model-item label="中控型号" prop="model">
          <a-select show-search :disabled="!addFlag" v-model="formState.model" placeholder="请选择中控型号">
            <a-select-option v-for="model in modelList" :key="model.model" :value="model.model">{{
              model.model
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="中控硬件版本" prop="hardVersion">
          <a-input :disabled="!addFlag" v-model="formState.hardVersion" placeholder="请输入中控硬件版本" />
        </a-form-model-item>
        <a-form-model-item label="最后修改时间" prop="lastModificationTime" v-if="!addFlag">
          <a-input :disabled="!addFlag" :value="formState.lastModificationTime | parseTime | orNA" />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea v-model="formState.remark" placeholder="备注" :rows="4" :max-length="64" />
          <span>{{ formState.remark ? formState.remark.length : 0 }}/64</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
export default {
  name: 'CpuHardwareAddOrEditModal',
  props: ['visible', 'item'],
  data() {
    return {
      formState:
        this.item === undefined
          ? {
              model: undefined,
              hardVersion: '',
              remark: '',
            }
          : this.item,
      modelList: [],
      rules: {
        model: [{ required: true, validator: this.validator, trigger: 'change' }],
        hardVersion: [{ required: true, validator: this.validator, trigger: 'blur' }],
      },
    };
  },
  methods: {
    cancelHandler() {
      this.$emit('update:visible', false);
    },
    async okHandler() {
      this.$refs.formState.validate(async (relsValid) => {
        if (relsValid) {
          if (this.addFlag) {
            await this.$apiManager.cpuHardware.addCpuHardware(this.formState);
          } else {
            const payload = {
              fields: ['remark'],
              data: this.formState,
            };
            await this.$apiManager.cpuHardware.updateCpuHardware(payload);
          }
          this.$message.success(this.addFlag ? '添加成功' : '修改成功');
          this.$emit('updateView');
          this.$emit('update:visible', false);
        }
      });
    },
    async getModelList() {
      const res = await this.$apiManager.cpuModel.getCpuModelList({ unpaged: true });
      this.modelList = res.data.elements;
    },
    validator(fields, option, callback) {
      const { field } = fields;
      let name;
      if (field === 'model') {
        name = '中控型号';
      }
      if (field === 'hardVersion') {
        name = '硬件版本';
      }
      if (option === '' || !option) {
        callback(`${name} 不能为空`);
        return;
      }
      // 只允许有大小写字母、整数、-、_规则，且以字母开头
      const regex = /^[a-zA-Z0-9][a-zA-Z0-9._-]*$/;
      if (!regex.test(option)) {
        callback(`${name}以字母开头或数字开头，只允许有大小写字母、整数、"-"、"_"、“.”`);
        return;
      }
      callback();
    },
  },
  computed: {
    addFlag() {
      return this.item === undefined;
    },
  },
  mounted() {
    if (this.addFlag) {
      this.getModelList();
    }
  },
};
</script>
<style lang="less" scoped></style>
